import { useDispatch, useSelector } from 'react-redux';

import ExplicitInformedConsent from '@app/components/ExplicitInformedConsent';
import { selectAddOns, setDisclosureChecked } from '@app/redux/addOns';

export const ConsentSection = ({
  consentRef,
  t,
}: {
  consentRef: React.RefObject<HTMLInputElement>;
  t: (key: string) => string;
}) => {
  const dispatch = useDispatch();
  const { isErrorDisclosureChecked, eicChecked, eicMessage } = useSelector(selectAddOns);

  return (
    <ExplicitInformedConsent
      id="stream_disclosure"
      label={t('label')}
      isChecked={eicChecked}
      onChange={() => dispatch(setDisclosureChecked(!eicChecked))}
      hasError={isErrorDisclosureChecked}
      errorMessage={t('errorMessageText')}
      disclosureText={eicMessage?.eicMessage ?? []}
      consentRef={consentRef}
    />
  );
};
